import React from 'react'

export default class ConpassScript extends React.Component {
    componentWillMount(){
        const {display_name: name, email} = this.props.user;
        const script = document.createElement('script');

        script.src = 'https://fast.conpass.io/_mzLN5DYx_IlF.js';
        script.type = 'text/javascript';
        script.async = true;

        script.addEventListener('load', () => {
            const {Conpass} = window;
            Conpass.init({name, email});
            console.log(`Conpass initialized (${name}/${email})`)
        });
        document.body.appendChild(script);
    }

    render() {
        return null
    }
}



// WEBPACK FOOTER //
// ./src/components/CustomComponents/ConpassScript/index.js